import React from 'react';

import {
  ContestReattempt,
  LESSON_TYPES,
  findLessonByLessonType,
} from 'features/classCreation';
import styles from './GroupContestSummary.module.scss';

function GroupContestSummary({ academyTopic }) {
  const { lessons } = academyTopic;
  const contestLesson = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.contest,
  });
  const { meta } = contestLesson || {};
  const { interviewbit_tests: interviewbitTests } = meta || {};

  return (
    <div className={styles.root}>
      {interviewbitTests.map((interviewbitTest) => (
        <ContestReattempt
          interviewbitTest={interviewbitTest}
          key={interviewbitTest.test_id}
          isClassTemplate
        />
      ))}
    </div>
  );
}

export default GroupContestSummary;
